import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppUpdateSplashService } from '@safarilaw-webapp/shared/app-bootstrap/data-access';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sl-rms-update-splash',
  templateUrl: './app-update-splash.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app-update-splash.scss']
})
export class AppUpdateSplashComponent extends SafariInjector implements OnInit, OnDestroy {
  showSplash = false;
  private _appUpdateSplashServiceSubscription: Subscription = null;
  private _appUpdateSplashService: AppUpdateSplashService;
  constructor() {
    super();
    this._appUpdateSplashService = this.inject(AppUpdateSplashService);
  }
  ngOnInit(): void {
    this._appUpdateSplashServiceSubscription = this._appUpdateSplashService.subscribe(() => {
      document.body.style.overflow = 'hidden';
    });
  }
  ngOnDestroy(): void {
    if (this._appUpdateSplashServiceSubscription) {
      this._appUpdateSplashServiceSubscription.unsubscribe();
      this._appUpdateSplashServiceSubscription = null;
    }
  }
  get errorMessage() {
    return window['swError'];
  }
}
